import React, { Fragment } from "react";
import BaseUIComponent from "../../Components/BaseUIComponent";
import { connect } from "react-redux";
import { getCountryMasterList, getCodeValueLabelList, getMessage } from "../../Constants/CommonConstants";
import { MessageMap } from "../MmGRSMMRMR31/GRSMMRMR31Message";
import { checkArray, isBlank } from "../../Components/Tools/StringTools";
import { createRecruitmentCaseSpecialSkill, createRecruitmentCaseSpecialSkillReset } from "../MmGRSMMRMR31/GRSMMRMR31Action";
import TextInput from "../../Components/Atoms/TextInput";
import Textarea from "../../Components/Atoms/Textarea";
import ErrorMessage from "../../Components/Atoms/ErrorMessage";
import Minus_Icon from "../../Images/btn_minus.svg";
import Plus_Icon from "../../Images/btn_plus.svg";
import NextButton_Icon from "../../Images/img_nextbtn.svg";
import "../../Css/Common.css";

/**
 * 求人案件登録（条件・勤務形態）
 */
class GRSMMRMR33 extends BaseUIComponent {
    constructor(props) {
        super(props);
        this.state = {
            candidate_sex: "",
            gender: [],
            country_select_flg: "",
            countryItems: [],
            occupation: "",
            content: "",
            job_working: [],
            work_day_fixed_free: "",
            work_others_free: "",
            holiday: "",
            holiday_number: "",
            isDisabled: false,
            recruitmentCaseInfo: this.props.recruitmentCaseInfo,
            recruitmentCaseDetail: this.props.recruitmentCaseDetail
        };
    }

    /**
     * 初期化イベント
     */
    componentDidMount = () => {
        const { recruitmentCaseDetail } = this.state;
        this.setState({
            candidate_sex: recruitmentCaseDetail.candidate_sex,
            country_select_flg: recruitmentCaseDetail.country_select_flg,
            countryItems: !isBlank(recruitmentCaseDetail.country) ? recruitmentCaseDetail.country.split(',') : "",
            occupation: recruitmentCaseDetail.occupation,
            content: recruitmentCaseDetail.content,
            job_working: recruitmentCaseDetail.job_working,
            work_shift: recruitmentCaseDetail.work_shift,
            work_day_fixed: recruitmentCaseDetail.work_day_fixed,
            work_day_fixed_free: recruitmentCaseDetail.work_day_fixed_free,
            work_others: recruitmentCaseDetail.work_others,
            work_others_free: recruitmentCaseDetail.work_others_free,
            holiday: recruitmentCaseDetail.holiday,
            holiday_number: recruitmentCaseDetail.holiday_number,
        }, () => {
            // 処理区分＝新規の場合の場合
            // 処理区分＝訂正 かつ 案件一覧情報．案件ステータス(作成中)
            // 処理区分＝訂正 かつ 案件一覧情報．案件ステータス(作成済) かつ 当日＜案件一覧情報．募集開始日の場合
            if ((this.props.createorupdate === 'create') ||
                (this.props.createorupdate === 'update' && recruitmentCaseDetail.case_status === '9') ||
                (this.props.createorupdate === 'update' && recruitmentCaseDetail.case_status === '2' && recruitmentCaseDetail.sys_date < recruitmentCaseDetail.pub_period_start)) {
                //【途中保存】ボタン表示
            } else {
                //【途中保存】ボタン非表示
                this.setState({ isDisabled: true });
            }
        });

        // 性別
        const genderRet = getCodeValueLabelList('RSC0007');
        this.setState(prevState => ({
            gender: [...prevState.gender, ...genderRet]
        }));
        window.scrollTo(0, 0);
    }

    /**
     * 性別変更
     * @param {*} event
     */
    handleGenderChange = (event) => {
        this.setState({ candidate_sex: event.target.value }, () => {
            this.editItemHandler('candidate_sex', this.state.candidate_sex);
        });
    };

    /**
     * 国籍指定
     * @param {*} event
     */
    handleDesignationChanged = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        }, () => {
            this.editItemHandler('country_select_flg', this.state.country_select_flg);
            if (this.state.country_select_flg === '0') {
                this.setState({ countryItems: [] }, () => {
                    this.editItemHandler('country', '');
                });
            }
        });
    };

    /**
     * 国・地域名の処理
     * @param {*} event
     */
    handleCountryChange = (event) => {
        const { value } = event.target;
        const { countryItems } = this.state;
        const presentIndex = [...countryItems].indexOf(value);

        // 存在しない場合
        if (presentIndex === -1) {
            this.setState({ countryItems: [...countryItems, value] }, () => {
                let items = "";
                this.state.countryItems.map((item, index) => {
                    items = items.concat(item, ',');
                });
                this.editItemHandler('country', items.substr(0, items.length - 1));
            });
        } else {
            countryItems.splice(presentIndex, 1);
            this.setState({ countryItems: countryItems }, () => {
                let items = "";
                this.state.countryItems.map((item, index) => {
                    items = items.concat(item, ',');
                });
                this.editItemHandler('country', items.substr(0, items.length - 1));
            });
        }
    };

    /**
     * 勤務時間を追加する
     */
    addWorkingHours = () => {
        this.setState(prevState => ({
            job_working: [...prevState.job_working, { "work_start": "", "work_end": "", "work_break": "", "work_hours": "" }]
        }), () => {
            this.editItemHandler('job_working', this.state.job_working);
        });
    }

    /**
     * 勤務時間を削除する
     * @param {*} index
     */
    deleteWorkingHours = (index) => {
        let array = [...this.state.job_working];
        array.splice(index, 1);
        this.setState({
            job_working: array
        }, () => {
            this.editItemHandler('job_working', this.state.job_working);
        });
    }

    /**
     * チェックボックスのon/offを変更する
     */
    handleChange = (event) => {
        const { checked, name } = event.target;
        let chk = checked ? '1' : '0';
        this.setState({
            [name]: chk
        }, () => {
            this.editItemHandler(name, chk);
        });
    }

    /**
     * 画面部品編集イベント
     * @param {*} name
     * @param {*} value
     */
    editItemHandler = (name, value) => {
        this.setState(prevState => ({
            recruitmentCaseDetail: {
                ...prevState.recruitmentCaseDetail,
                [name]: value
            }
        }));
    }

    /**
 * 画面部品編集イベント
 * @param {*} index
 * @param {*} name
 * @param {*} value
 */
    editItemHandlerByObject = (index, name, value) => {
        this.setState({
            job_working: this.state.job_working.map((item, _index) =>
                _index == index ? { ...item, [name]: value } : item
            )
        }, () => {
            this.editItemHandler('job_working', this.state.job_working);
        });
    }

    /**
     * ローディング、エラー画面リセット
     */
    saveReset = () => {
        this.props.createRecruitmentCaseSpecialSkillReset();
    }

    /**
     * 途中保存
     */
    temporalySave = () => {
        this.props.createRecruitmentCaseSpecialSkillReset();
        window.scrollTo(0, 0);
        // システムエラーのコールバック設定
        this.setErrorCallback(this.saveReset);
        let recruitmentCaseDetailData = this.state.recruitmentCaseDetail;
        if (isBlank(recruitmentCaseDetailData.case_id)) {
            if (this.props.data && this.props.data.case_id != null) {
                recruitmentCaseDetailData.case_id = this.props.data.case_id;
            }
        }
        recruitmentCaseDetailData.temp_save = '1';
        this.setState({
            recruitmentCaseDetail: recruitmentCaseDetailData
        }, async () => {
            let reqData = JSON.parse(JSON.stringify(this.state.recruitmentCaseDetail));
            const ret = await this.props.uploadImageFiles(reqData.case_image);
            if (ret) {
                if (reqData.case_image && reqData.case_image.length > 0) {
                    // 一時ファイル削除記録
                    let fileNameList = [];
                    reqData.case_image.map(image => {
                        if (!isBlank(image.image_content)) {
                            fileNameList.push(image.image_content);
                        }
                    });
                    if (fileNameList.length > 0) {
                        this.setState({ imageFileNameList: fileNameList });
                    }
                }
                this.props.createRecruitmentCaseSpecialSkill(reqData);
            }
        });
    }

    /**
     * 画面切替処理
     * @param {*} changeTo
     * @param {*} isReset
     */
    handleToDisplay = (changeTo, isReset) => {
        if (isReset) {
            this.props.getCaseDetailReset();
        }
        return this.props.changeDisp(changeTo, isReset);
    }

    /**
     * 次へ
     * @param {*} changeTo
     * @param {*} outline
     * @param {*} detail
     */
    skipToNext = (changeTo, outline, detail) => {
        return this.props.skipToNext(changeTo, outline, detail);
    }

    render() {
        const { recruitmentCaseDetail, recruitmentCaseInfo, countryItems, isDisabled, job_working } = this.state;

        if (!this.props.isFetching) {
            // 最新バージョン設定する
            if (this.props.data && this.props.data.version_no != null && recruitmentCaseDetail.version_no != this.props.data.version_no) {
                let recruitmentCaseDetailData = recruitmentCaseDetail;
                recruitmentCaseDetailData.version_no = this.props.data.version_no;
                this.setState({
                    recruitmentCaseDetail: recruitmentCaseDetailData
                });
                if (this.state.imageFileNameList && this.state.imageFileNameList.length > 0) {
                    const deleteList = this.state.imageFileNameList;
                    this.setState({
                        imageFileNameList: null
                    }, () => {
                        this.props.deleteImageFiles(deleteList);
                        this.showModalDialog(0, getMessage('RS-0074'), () => { });
                    });
                } else {
                    this.showModalDialog(0, getMessage('RS-0074'), () => { });
                }
            }
            if (!isBlank(this.props.err_type) && this.props.err_type != '200') {
                // 入力チェックなどエラーが発生時に一時ファイル削除
                if (this.state.imageFileNameList && this.state.imageFileNameList.length > 0) {
                    const deleteList = this.state.imageFileNameList;
                    this.setState({
                        imageFileNameList: null
                    }, () => {
                        this.props.deleteImageFiles(deleteList);
                    });
                }
            }
        }

        const count = Object.keys(getCountryMasterList()).length;

        const tabindex = 4 + count - (count - 1);
        const tabNum = tabindex + 3 + job_working.length;

        // 国籍指定
        const designation = getCodeValueLabelList('RSC0009');

        return (
            <Fragment>
                <div className="ly_cont">
                    <div className="bl_mainHeader">
                        <div className="bl_mainHeader_inner">
                            <h1 className="el_lv1Heading">求人案件管理</h1>
                        </div>
                    </div>
                    <div className="ly_mainCont">
                        <nav className="bl_breadcrumb">
                            <ol className="bl_breadcrumb_list">
                                <li>
                                    <a href="#!" onClick={() => this.showModalDialog(1, getMessage('RS-0066'), () => { this.getMenu().gotoHome(); }, () => { })}>ホーム</a>
                                </li>
                                <li>
                                    <a href="#" onClick={() => this.showModalDialog(1, getMessage('RS-0066'), () => { this.handleToDisplay("GRSMMMLI01", true); }, () => { })}>案件一覧</a>
                                </li>
                                <li>求人案件登録</li>
                            </ol>
                        </nav>
                        <section className="bl_sect">
                            <div className="ly_mainCont_inner">
                                <div className="bl_sect_header">
                                    <h2 className="el_lv2Heading">求人案件登録</h2>
                                </div>
                                <ErrorMessage err_type={this.props.err_type} err_detail={this.props.err_detail} messageMap={MessageMap} />
                                <ErrorMessage err_type={this.props.err_type_upload} err_detail={this.props.err_detail_upload} messageMap={MessageMap} />
                                <div className="bl_sect_inner">
                                    <div className="bl_stepbarUnit">
                                        <ol className="bl_stepbar">
                                            <li className="bl_stepbar_item">
                                                <a href="#" className="bl_stepbar_link" onClick={() => this.skipToNext("GRSMMRMR31", recruitmentCaseInfo, recruitmentCaseDetail)}>募集手続</a>
                                            </li>
                                            <li className="bl_stepbar_item">
                                                <a href="#" className="bl_stepbar_link" onClick={() => this.skipToNext("GRSMMRMR32", recruitmentCaseInfo, recruitmentCaseDetail)}>会社情報</a>
                                            </li>
                                            <li className="bl_stepbar_item is_current">
                                                <span>条件・勤務形態</span>
                                            </li>
                                            <li className="bl_stepbar_item is_disabled">
                                                <span>待遇</span>
                                            </li>
                                            <li className="bl_stepbar_item is_disabled">
                                                <span>施設紹介</span>
                                            </li>
                                            <li className="bl_stepbar_item is_disabled">
                                                <span>周辺情報</span>
                                            </li>
                                            <li className="bl_stepbar_item is_disabled">
                                                <span>サポート<br />サービス</span>
                                            </li>
                                            <li className="bl_stepbar_item is_disabled">
                                                <span>登録完了</span>
                                            </li>
                                        </ol>
                                    </div>
                                    <div className="bl_horizBtnUnit bl_horizBtnUnit__blue">
                                        <button type="button" className="el_backBtn" onClick={() => this.skipToNext("GRSMMRMR32", recruitmentCaseInfo, recruitmentCaseDetail)} tabIndex={tabNum + 13}>戻る</button>
                                        <button type="button" className="el_nextBtn" onClick={() => this.skipToNext("GRSMMRMR34", recruitmentCaseInfo, recruitmentCaseDetail)} tabIndex={tabNum + 12}>次へ</button>
                                    </div>
                                    <div className="bl_sect_desc">
                                        <p>以下の項目を入力し、<span className="un_nextBtnImg"><img src={NextButton_Icon} alt="次へ" /></span>ボタンを押してください。<span className="el_badge el_badge__required hp_mr5">必須</span>のついた項目は必須入力です。</p>
                                    </div>
                                    <section className="bl_sect_frame">
                                        <div className="bl_sect_header">
                                            <h3 className="el_lv3Heading"><span>条件・勤務形態</span></h3>
                                        </div>
                                        <table className="bl_horizTable">
                                            <tbody>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        性別
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <select className="el_select" name="candidate_sex" onChange={this.handleGenderChange} tabIndex="1">
                                                                {
                                                                    this.state.gender.map(item => (
                                                                        <option key={item.value} value={item.value} selected={recruitmentCaseDetail.candidate_sex == item.value}>
                                                                            {item.label}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        国籍
                                                    </th>
                                                    <td>
                                                        {
                                                            designation.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <div className="bl_formUnit hp_mb15" key={index}>
                                                                            <input type="radio" name="country_select_flg" value={item.value} checked={this.state.country_select_flg === item.value}
                                                                                onChange={this.handleDesignationChanged} tabIndex={1 + index + 1} />
                                                                            <span className="hp_mr20">{item.label}</span>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                        <div className="bl_formUnit">
                                                            {
                                                                Object.entries(getCountryMasterList()).map(([k, v]) => {
                                                                    if (v.country_code !== "JPN") {
                                                                        return (
                                                                            <label className="el_label" key={v.country_number}>
                                                                                <input type="checkbox" className="el_checkbox"
                                                                                    name={v.country_name}
                                                                                    value={v.country_code}
                                                                                    checked={countryItems.includes(v.country_code)}
                                                                                    onChange={this.handleCountryChange} disabled={this.state.country_select_flg === '0'}
                                                                                    tabIndex={tabindex} />
                                                                                <span className="el_checkbox_txt">{v.country_name}</span>
                                                                            </label>
                                                                        );
                                                                    }
                                                                })
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        募集職種
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <TextInput type="text" name="occupation" className="el_input el_input__max" maxlength="60" required="required" setValue={recruitmentCaseDetail.occupation} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex={tabindex + 1} />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        業務内容
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <Textarea name="content" className="el_textarea" rows="10" maxlength="618" required="required" setValue={recruitmentCaseDetail.content} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex={tabindex + 2} />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        勤務時間
                                                    </th>
                                                    <td>
                                                        <table className="el_tableNoFrame">
                                                            <tbody>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>始業</th>
                                                                    <th>終業</th>
                                                                    <th>休憩</th>
                                                                    <th>実働</th>
                                                                </tr>
                                                                {
                                                                    job_working.map((item, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <th>{index + 1}</th>
                                                                                <td>
                                                                                    <TextInput type="time" name="work_start" className="el_input el_input__sm" maxlength="5" required="required"
                                                                                        setValue={item.work_start} onHandleChange={(k, v) => this.editItemHandlerByObject(index, k, v)} placeholder="--:--" tabIndex={tabindex + 3} />
                                                                                </td>
                                                                                <td>
                                                                                    <TextInput type="time" name="work_end" className="el_input el_input__sm" maxlength="5" required="required"
                                                                                        setValue={item.work_end} onHandleChange={(k, v) => this.editItemHandlerByObject(index, k, v)} placeholder="--:--" tabIndex={tabindex + 3} />
                                                                                </td>
                                                                                <td>
                                                                                    <TextInput type="time" name="work_break" className="el_input el_input__sm" maxlength="5" required="required"
                                                                                        setValue={item.work_break} onHandleChange={(k, v) => this.editItemHandlerByObject(index, k, v)} placeholder="--:--" tabIndex={tabindex + 3} />
                                                                                </td>
                                                                                <td>
                                                                                    <TextInput type="time" name="work_hours" className="el_input el_input__sm" maxlength="5" required="required"
                                                                                        setValue={item.work_hours} onHandleChange={(k, v) => this.editItemHandlerByObject(index, k, v)} placeholder="--:--" tabIndex={tabindex + 3} />
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                        <div className="bl_horizBtnUnit bl_horizBtnUnit__r hp_mb15">
                                                            <button type="button" value="-" className="el_funcBtn" onClick={() => this.deleteWorkingHours(job_working.length - 1)} disabled={job_working.length > 1 ? false : true}>
                                                                <img style={{ opacity: job_working.length <= 1 ? 0.5 : 1.0 }} src={Minus_Icon} alt="マイナス" tabIndex={tabNum + 1} />削除
                                                            </button>
                                                            <button type="button" value="+" className="el_funcBtn" onClick={() => this.addWorkingHours()} disabled={job_working.length >= 9 ? true : false}>
                                                                <img style={{ opacity: job_working.length >= 9 ? 0.5 : 1.0 }} src={Plus_Icon} alt="プラス" tabIndex={tabNum + 2} />追加
                                                            </button>
                                                        </div>
                                                        <label className="el_label">
                                                            <input className="el_checkbox" type="checkbox" name="work_shift" checked={this.state.work_shift === '1'} onChange={this.handleChange} tabIndex={tabNum + 3} />
                                                            <span className="el_checkbox_txt">シフトにより決定</span>
                                                        </label>
                                                        <div className="bl_formFlex">
                                                            <label className="el_label">
                                                                <input className="el_checkbox" type="checkbox" name="work_day_fixed" checked={this.state.work_day_fixed === '1'} onChange={this.handleChange} tabIndex={tabNum + 4} />
                                                                <span className="el_checkbox_txt">曜日固定</span>
                                                            </label>
                                                            <TextInput type="text" name="work_day_fixed_free" className="el_input el_input__lg" maxlength="20" required="required" setValue={recruitmentCaseDetail.work_day_fixed_free} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex={tabNum + 5} />
                                                        </div>
                                                        <div className="bl_formFlex">
                                                            <label className="el_label">
                                                                <input className="el_checkbox" type="checkbox" name="work_others" checked={this.state.work_others === '1'} onChange={this.handleChange} tabIndex={tabNum + 6} />
                                                                <span className="el_checkbox_txt">その他</span>
                                                            </label>
                                                            <TextInput type="text" name="work_others_free" className="el_input el_input__lg" maxlength="20" required="required" setValue={recruitmentCaseDetail.work_others_free} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex={tabNum + 7} />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />休日
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <TextInput type="text" name="holiday" className="el_input el_input__max" maxlength="40" required="required" setValue={recruitmentCaseDetail.holiday} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex={tabNum + 8} />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        休日数
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <TextInput type="text" name="holiday_number" className="el_input el_input__sm text_right_align" inputmode="decimal" maxlength="2" required="required" setValue={recruitmentCaseDetail.holiday_number} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex={tabNum + 9} />
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </section>
                                    <div className="bl_horizBtnUnit">
                                        <button type="button" className="el_saveBtn" style={{ display: isDisabled ? 'none' : 'block' }} onClick={() => this.temporalySave()} tabIndex={tabNum + 10}>途中保存</button>
                                        <button type="button" className="el_nextBtn" onClick={() => this.skipToNext("GRSMMRMR34", recruitmentCaseInfo, recruitmentCaseDetail)} tabIndex={tabNum + 11}>次へ</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// この関数は第一引数はstore.getState()の結果を第一引数に、このContainer componentへ渡されたpropsを第二引数にして呼び出され、
// これらのstateとpropsを使って子のcomponentにpropsとして渡す値を生成する
const mapStateToProps = (state) => {
    return {
        isFetching: state.createRecruitmentCaseSpecialSkill.isFetching,
        data: state.createRecruitmentCaseSpecialSkill.recruitmentCaseData,
        isError: state.createRecruitmentCaseSpecialSkill.isError,
        err_type: state.createRecruitmentCaseSpecialSkill.err_type,
        err_detail: state.createRecruitmentCaseSpecialSkill.err_detail,
        err_type_upload: state.uploadInfo.err_type,
        err_detail_upload: state.uploadInfo.err_detail
    };
};

// この関数は，store.dispatchを第一引数にして呼び出される関数で、
// dispatchを使って子のcomponentにpropsとして渡す関数を生成する
const mapDispatchToProps = dispatch => {
    return {
        createRecruitmentCaseSpecialSkill(arg) {
            // actionCreatorの関数を使用してactionをdispatchに返してそれを実行している。
            // その後、createStoreで登録したreducerに処理が移る
            dispatch(createRecruitmentCaseSpecialSkill(arg));
        },
        createRecruitmentCaseSpecialSkillReset() {
            // actionCreatorの関数を使用してactionをdispatchに返してそれを実行している。
            // その後、createStoreで登録したreducerに処理が移る
            dispatch(createRecruitmentCaseSpecialSkillReset());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GRSMMRMR33);

